// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__pBJ5p","gfeWrapper":"CalendarEvent_gfeWrapper__3T3ta"};